export default __webpack_public_path__ + "3260d7ff35e9b21e37d6e568a43e1e16.png";